import apiClient from './apiClient';

export const journalApi = {
    // ---- Projects ----
    getProjects: () => apiClient.get('/api/projects').then(res => res.data),
    getProjectPermissions: () => apiClient.get('/api/projects/permissions').then(res => res.data),
    getAllProjectsStatus: () => apiClient.get('/api/projects?status=all').then(res => res.data),

    // ---- Entries ----
    getEntries: (projectId) => apiClient.get(`/api/journal?project_id=${projectId}`).then(res => res.data),
    createEntry: (entryData) => apiClient.post('/api/journal', entryData).then(res => res.data),
    updateEntry: (id, entryData) => apiClient.put(`/api/journal/${id}`, entryData).then(res => res.data),
    deleteEntry: (id) => apiClient.delete(`/api/journal/${id}`).then(res => res.data),
    bulkDeleteEntries: (ids) => apiClient.delete('/api/journal/bulk-delete', { data: { ids } }).then(res => res.data),

    // ---- Approvals ----
    approveEntry: (id) => apiClient.put(`/api/journal/${id}/approve`).then(res => res.data),
    rejectEntry: (id, reason) => apiClient.put(`/api/journal/${id}/reject`, { reason }).then(res => res.data),

    // ---- Attachments & Transcripts ----
    addAttachments: (entryId, formData) => apiClient.post(`/api/journal/${entryId}/attachments`, formData, { headers: { 'Content-Type': 'multipart/form-data' } }).then(res => res.data),
    deleteAttachment: (entryId, attId) => apiClient.delete(`/api/journal/${entryId}/attachments/${attId}`).then(res => res.data),
    renameAttachment: (entryId, attId, newName) => apiClient.patch(`/api/journal/${entryId}/attachments/${attId}/rename`, { newName }).then(res => res.data),
    transcribeAudio: (formData) => apiClient.post('/api/journal/transcribe', formData, { headers: { 'Content-Type': 'multipart/form-data' } }).then(res => res.data),
    updateTranscript: (entryId, attId, transcript) => apiClient.patch(`/api/journal/${entryId}/attachments/${attId}/transcript`, { transcript }).then(res => res.data)
};
